import React, { ComponentProps } from 'react';
// Components
import ILink from '../../types/ILink';
import { PortalAvatar } from '../../types/api/ImageType';
import Hyperlink from '../../components/atoms/Hyperlink/Hyperlink';
import { accessKeys } from '../../types/AccessKeys';
import { BlockGuard } from '../../types/api/Block';
import { BlockType } from '../../types/api/ElementType';
import { asBlock } from '../../_lib/BlockFetcher';
import { useAppContext } from '../../contexts/AppContext/AppContext';

type InstitutionDisplayProps = {
  institutionTitle: string;
  link: ILink;
  institutionImage: PortalAvatar;
};

/**
 * Renders the icon and the title of the institution.
 */
export function InstitutionDisplay({
  institutionImage: { src },
  institutionTitle,
  link: { name, url },
}: InstitutionDisplayProps) {
  const { userInfo } = useAppContext();

  const accessKey = userInfo?.settings?.accessKeysEnabled ? accessKeys.homepage : undefined;

  return (
    <div className="wrapper__institution-display">
      <div className="institution-display">
        {/* if used correctly and wisely, accesskeys are a11y enhancement */}
        {/* eslint-disable-next-line jsx-a11y/no-access-key */}
        <Hyperlink to={url} className="institution-display__link" accessKey={accessKey}>
          <img className="institution-display__insitution-logo" src={src} alt={name} />
          <span className="institution-display__textcontainer">
            <span className="institution-display__institution">{institutionTitle}</span>
          </span>
        </Hyperlink>
      </div>
    </div>
  );
}

export const InstitutionDisplayBlock = asBlock(InstitutionDisplay, BlockType.institutiondisplay);
export type InstitutionDisplayBlock = ComponentProps<typeof InstitutionDisplayBlock>;
export const isInstitutionDisplayBlock = BlockGuard<InstitutionDisplayBlock>(BlockType.institutiondisplay);
